import { testEventHasVirtDuration } from '@racemap/utilities/functions/timing';
import _ from 'lodash';
import type { FC } from 'react';
import { useSelectedEventData } from 'src/store/leaderboard/leaderboard_reducer';
import { Devider } from '../../BasicComponents/Devider/Devider';
import { TeamTargetPanel } from '../TeamTargetPanel/TeamTargetPanel';
import { appendNoneTags } from './Columns/TagCol';
import { TableBody } from './TableBody';

export const Table: FC = () => {
  const eventData = useSelectedEventData();

  if (eventData == null) return <></>;
  const { eventObject, starterData, tags } = eventData;
  const eventDataWithNoneTags = appendNoneTags(starterData, tags);

  const teamTarget = eventObject.modules.timing.teamTarget;
  const totalDistance = _.sumBy(eventDataWithNoneTags.starters, (i) =>
    i.progress > 0 ? i.progress : 0,
  );
  const eventHasVirtDuration = testEventHasVirtDuration(eventObject);
  const unitType = eventObject.playerOptions.unitType;

  return (
    <>
      {teamTarget.enabled && !eventHasVirtDuration && (
        <>
          <TeamTargetPanel
            teamTarget={teamTarget}
            totalDistance={totalDistance}
            unitType={unitType}
          />
          <Devider style={{ marginBottom: 0 }} />
        </>
      )}
      <TableBody />
    </>
  );
};
